var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Обновить задачи",
              loading: _vm.loading,
              color: _vm.$constants.PRIMARY_COLOR,
              onClick: () => _vm.getRecords(),
              className: "btn btn-outline-info",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.records.length
        ? [
            _c("table", { staticClass: "table mt-0 table-sm table-hover" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.records, function (r, i) {
                    return [
                      _c("tr", [
                        _c(
                          "td",
                          { attrs: { rowspan: r.task_data.length + 1 } },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  i +
                                    1 +
                                    (_vm.paginator.current_page - 1) *
                                      _vm.paginator.per_page
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.printDate(r.created_at))),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(r.task_data, function (c) {
                        return _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "badge badge-dark" }, [
                              _vm._v(_vm._s(_vm.types[c.use_type_id])),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(c.number) +
                                " (" +
                                _vm._s(c.slot) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              !c.sms_report_id
                                ? [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-clock-o",
                                    }),
                                  ]
                                : [_c("strong", [_vm._v(_vm._s(c.amount))])],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td"),
                        ])
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _vm.paginator
                  ? _c("paginate", {
                      attrs: {
                        "page-count": _vm.paginator.last_page,
                        "page-range": 3,
                        "margin-pages": 2,
                        "click-handler": _vm.getRecords,
                        "prev-text": "&laquo",
                        "next-text": "&raquo",
                        "container-class": "pagination",
                        "prev-class": "page-item",
                        "prev-link-class": "page-link",
                        "page-class": "page-item",
                        "page-link-class": "page-link",
                        "next-class": "page-item",
                        "next-link-class": "page-link",
                        "active-class": "active green_btn",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Карты")]),
        _vm._v(" "),
        _c("th", [_vm._v("SMS")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }